export default __webpack_public_path__ + "static/media/sukuklogo.8edfb3c1.png";